export const canvasConfig = {
    "width": 200,
    "height": 1000
}
